import { render, staticRenderFns } from "./Create.vue?vue&type=template&id=3557e99c&scoped=true"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3557e99c",
  null
  
)

export default component.exports